import Api from './api';

class Regions {
    static async get() {
        return await Api.get('region-service/get');
    }
    static async post(name) {
        return await Api.post('region-service/add', { name });
    }
    static async delete(id) {
        return await Api.post('region-service/delete', { id: String(id) });
    }
    static async update({ id, oldName, newName }) {
        return await Api.post('region-service/rename', { idRegion: String(id), oldName, newName });
    }
    static async getCountries(idRegion) {
        return await Api.get('region-service/get-countries', { idRegion });
    }
    static async moveCountry(idCountry, idRegion) {
        return await Api.post('region-service/move-countries-to-region', { idRegion: String(idRegion), countries: [idCountry] });
    }
}

export default Regions;